import { last, equals, head } from 'lodash/fp';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useStorageState } from 'react-storage-hooks';

const LOCATION_HISTORY_KEY = 'LOCATION-HISTORY';
const getStoredHistory = () => JSON.parse(sessionStorage.getItem(LOCATION_HISTORY_KEY) || '[]');
const storeHistory = (data: any) => {
  sessionStorage.setItem(LOCATION_HISTORY_KEY, JSON.stringify(data));
};

export const useRegisterNavigationHistory = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const lastPathNames = getStoredHistory();
    const lastLocation = last(lastPathNames);

    if (equals(lastLocation, pathname)) return;
    lastPathNames.push(pathname);
    storeHistory(lastPathNames.slice(-20));
  }, [pathname]);
};

export const useNavigationHistory = () => {
  const { pathname } = useLocation();
  const [prevLocation, setPrevLocation] = useState('');
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      const storedHistory = getStoredHistory();
      const previousLocation = storedHistory[storedHistory.length - 2];
      setPrevLocation(previousLocation);
    });
  }, [setPrevLocation, pathname]);

  const goBack = useCallback(() => {
    const storedHistory = getStoredHistory();
    const previousLocation = storedHistory[storedHistory.length - 2];
    storedHistory.pop();
    storeHistory(storedHistory);
    history.push(previousLocation);
  }, [history]);

  return {
    prevLocation,
    goBack,
  };
};
